<template>
  <div class="step">
    <span class="circle">{{ props.stepNumber }}</span>
    <h4>{{ props.title }}</h4>
    <span v-if="props.required" class="ml-2 text-red-600">*</span> <br />
  </div>
  <div class="step-body" :class="{ 'opacity-50': props.isDisabled }">
    <slot />
  </div>
</template>
<script lang="ts" setup>
  const props = defineProps<{
    stepNumber: number
    title: string
    required?: boolean
    isDisabled?: boolean
  }>()
</script>
<style scoped>
  .step {
    display: flex;
    width: 100%;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    margin-top: 1rem;
  }

  .step .circle {
    width: 24px;
    height: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 999px;
    border-color: #3b82f6;
    background-color: #3b82f6;
    color: white;
    font-size: 12px;
    margin-right: 10px;
  }

  .step-body {
    display: flex;
    flex-direction: row;
    width: 97%;
    flex-wrap: wrap;
    margin-top: 1rem;
    margin-left: 3rem;
  }
</style>
